import {
  Box,
  Button,
  Center,
  FormControl,
  FormHelperText,
  FormLabel,
  Heading,
  HStack,
  Input,
  Stack,
} from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import {useState} from 'react'
import WrapContent from '../components/WrapContent';
import { useCtx } from '../context/AppContext';

const SignUp = () => {
  const {merchantSignUp} =  useCtx();
  const [username, setUserName] = useState('');
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');

  const signUp = async (e) => {
    e.preventDefault();
    await merchantSignUp(username);
    const merchantdata = {name: name, username: username, email: email};
    localStorage.setItem("merchantdata", JSON.stringify(merchantdata));
    window.location.href = "/merchant"
  }

  return (
    <Box bg="gray.50">
      <WrapContent>
        <HStack justifyContent={'space-between'}>
          <Box py="5">
            <u>
              <Link to="/signin">Login instead?</Link>
            </u>
          </Box>
          <Box py="5">
            <u>
              <Link to="/">Go back Home</Link>
            </u>
          </Box>
        </HStack>

        <Center minH="100vh">
          <Stack spacing="5" maxW="400px" py="60px">
            <Heading as="h1">CREATE ACCOUNT</Heading>
            <Stack spacing="5">
              <FormControl>
                <FormLabel mb="-0.5" htmlFor="name">
                  Full name
                </FormLabel>
                <Input size="md" type="text" placeholder="write full name" onChange={e => setName(e.currentTarget.value)}/>
              </FormControl>
              <FormControl>
                <FormLabel mb="-0.5" htmlFor="username" >
                  Username
                </FormLabel>

                <Input size="md" type="text" placeholder="write username" onChange={e => setUserName(e.currentTarget.value)}/>
              </FormControl>
              <FormControl>
                <FormLabel mb="-0.5" htmlFor="email">
                  Email
                </FormLabel>

                <Input size="md" type="email" placeholder="enter email" onChange={e => setEmail(e.currentTarget.value)}/>
              </FormControl>
              <FormControl>
                <FormLabel mb="-0.5" htmlFor="password">
                  Password
                </FormLabel>

                <Input size="md" type="password" placeholder="password" />
              </FormControl>
              <FormControl>
                <FormLabel mb="-0.5" htmlFor="confirmpassword">
                  Confirm password
                </FormLabel>

                <Input
                  size="md"
                  type="password"
                  placeholder="confirm password"
                />
              </FormControl>
              <FormControl>
                <FormHelperText>
                  By Creating an account, i consent to the processing of my data
                  in accordance with the <b>Privacy Policy</b>
                </FormHelperText>
              </FormControl>
              <Button rounded="lg" colorScheme={'teal'} type="submit" onClick={signUp}>
                CREATE
              </Button>
            </Stack>
          </Stack>
        </Center>
      </WrapContent>
    </Box>
  );
};

export default SignUp;
